import { CircleAlert, RotateCcw } from "lucide-react";

export function ErrorPanel({
  message,
  onReset,
}: {
  readonly message: string;
  readonly onReset: () => void;
}) {
  return (
    <section className="status-panel error-panel" role="alert">
      <span className="error-orb">
        <CircleAlert size={38} />
      </span>
      <h2>本次处理未完成</h2>
      <p>{message}</p>
      <button className="primary-action" type="button" onClick={onReset}>
        <RotateCcw size={18} />
        重新选择文件
      </button>
    </section>
  );
}
